import instance from "utils/axios.utils";

const Config = {
    getConfig: () => {
        let promise = new Promise((resolve, reject)=>{
          let url = "config/get_config";
          instance().post(url, {}).then(res=>{
            resolve(res.data)
          }).catch(error=>{
            if(error.response){
              reject(error.response.data.message)
            }else{
              reject(error)
            }
          })
        })
        return promise
      },
}

export default Config;